import { sessionUtility } from "acss-mvo-ts-components";
export const getConfig = ({ configData = {} }) => {
  let config = {};
  const { delphiSiteSurveySummaryIds = "", enableDelphiBannerIds = "", productId="", accessoryCategory="", accessoryId="", processAction="", isOptimisedFlow=false, cartUrl="" } = configData;

  try {
    if (window?.config?.troubleShootingJson) {
      window.troubleShootingJson = window.config.troubleShootingJson;
      window.isFwa = window?.troubleShootingJson?.ddata?.device?.isFwa;
      window.oemdevice = window?.troubleShootingJson?.ddata?.device?.deviceOem;
    }

    if (window?.config?.caseDetails) {
      window.caseDetails = window.config.caseDetails;
    }

    config = window.config || {};
    const networkExtenderOptions={};
    networkExtenderOptions.productId = productId;
    networkExtenderOptions.accessoryCategory = accessoryCategory;
    networkExtenderOptions.accessoryId = accessoryId;
    networkExtenderOptions.processAction = processAction;
    networkExtenderOptions.cartUrl = cartUrl;
    config.networkExtenderOptions = networkExtenderOptions;
    config.isBAUACSS = false;
    console.log("index config", config);
    config.troubleShootingJson = window.troubleShootingJson;
    config.caseDetails = window.caseDetails;
    config.delphiSiteSurveySummaryIds = delphiSiteSurveySummaryIds;
    config.enableDelphiBannerIds = enableDelphiBannerIds;
    config.isOptimisedFlow = isOptimisedFlow;
    console.log("index config", config);
    sessionUtility.setMvoConfig(config);
    sessionUtility.setCaseDetails(config.caseDetails);
  } catch (error) {
    console.error("src/index.js error", error);
  }

  return config;
};
